module.exports = __webpack_public_path__ + "img/stapler_hl.19fe8422.png";